import { render, staticRenderFns } from "./MaterialGuide.vue?vue&type=template&id=7c07143e"
import script from "./MaterialGuide.vue?vue&type=script&lang=js"
export * from "./MaterialGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports